<template>
    <div class="semi-process">
        <h2 class="page-title">半流程-项目管理</h2>

        <div class="list-card">
            <div class="list-card__header">
                <span class="list-card__title">项目信息列表</span>
                <el-button type="primary" icon="el-icon-plus" class="add-btn" @click="handleAddProject">新增项目</el-button>
            </div>

            <el-table :data="tableData" border class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="projectName" label="项目名称"  show-overflow-tooltip />
                <el-table-column prop="sectionCount" label="标段数量" align="center" />
                <el-table-column prop="bidDocFee" label="标书数（元）" width="120" align="center" />
                <el-table-column prop="drawingDeposit" label="图纸押金（元）"  align="center" />
                <el-table-column prop="downloadSetting" label="下载设置"  show-overflow-tooltip />
                <el-table-column prop="status" label="状态"  align="center">
                    <template slot-scope="scope">
                        <span class="status-tag status-tag--success">{{ scope.row.status }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180" align="center" />
                <el-table-column label="操作" width="160" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" class="action-btn" @click="handleDetail(scope.row)">详情</el-button>
                        <el-button type="text" class="action-btn" @click="handleEnterFlow(scope.row)">进入流程</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SemiProcessIndex',

    data() {
        return {
            tableData: [
                {
                    no: 1,
                    projectName: '中山大厦建设项目',
                    sectionCount: '1个',
                    bidDocFee: 500,
                    drawingDeposit: 1000,
                    downloadSetting: '本平台公开下载',
                    status: '已提交',
                    createTime: '2025-09-15 10:30:00'
                }
            ]
        }
    },

    methods: {
        // 新增项目
        handleAddProject() {
            this.$router.push('/agentHome/addProject')
        },
        handleDetail(row) {
            console.log('详情', row)
        },
        handleEnterFlow(row) {
            this.$router.push({
                path: '/agentHome/projectWorkflow',
                query: {
                    projectName: row.projectName,
                    projectCode: row.projectCode || 'E1101050893002128'
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.semi-process {
    padding: 0;
    background: transparent;
    min-height: calc(100vh - 64px);
}

.page-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 16px 0;
    padding: 0;
}

.list-card {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border-bottom: 1px solid #EBEEF5;
    }

    &__title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
    }

    .add-btn {
        font-weight: 500;
    }
}

/deep/ .data-table {
    border: none;
    border-radius: 0 0 4px 4px;

    &::before,
    &::after {
        display: none;
    }

    th.el-table__cell {
        background: #fff;
        color: #606266;
        font-weight: 500;
        font-size: 14px;
        border-bottom: 1px solid #EBEEF5;
        padding: 12px 0;
    }

    td.el-table__cell {
        padding: 14px 0;
        font-size: 14px;
        color: #606266;
        border-bottom: 1px solid #F2F6FC;
    }

    tr.el-table__row--striped td.el-table__cell {
        background: #FAFAFA;
    }
}

.status-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 12px;
    line-height: 18px;
    border: 1px solid;
    background: #f0f9eb;

    &--success {
        color: #67C23A;
        border-color: #c2e7b0;
    }
}

.action-btn {
    color: #409EFF;
    font-size: 14px;
    padding: 4px 6px;
}
</style>
